import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronDoubleLeftIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.84 11.96L11.2 4.6L12.62 6.02L6.68 11.96L12.62 17.9L11.2 19.32L3.84 11.96ZM11.42 11.96L18.78 4.6L20.2 6.02L14.26 11.96L20.2 17.9L18.78 19.32L11.42 11.96Z" />
    </SvgIcon>
  );
});
